/** BCP 47 — 与 GCSA 主站 / gcsa-ui 组件 locale prop 一致 */
export const SITE_FOOTER_LOCALES = [
  'zh-CN',
  'zh-TW',
  'en-US',
  'th-TH',
  'id-ID',
  'ko-KR',
  'ja-JP',
  'vi-VN',
  'ms-MY'
] as const;

export type SiteFooterLocale = (typeof SITE_FOOTER_LOCALES)[number];

const LOCALE_SET = new Set<string>(SITE_FOOTER_LOCALES);

export function isSiteFooterLocale(value: string): value is SiteFooterLocale {
  return LOCALE_SET.has(value);
}

export function normalizeSiteFooterLocale(locale?: string): SiteFooterLocale {
  if (!locale) {
    return 'zh-CN';
  }
  if (isSiteFooterLocale(locale)) {
    return locale;
  }
  if (locale.startsWith('zh')) {
    return locale.includes('TW') || locale.includes('Hant') ? 'zh-TW' : 'zh-CN';
  }
  if (locale.startsWith('en')) {
    return 'en-US';
  }
  if (locale.startsWith('th')) {
    return 'th-TH';
  }
  if (locale.startsWith('id')) {
    return 'id-ID';
  }
  if (locale.startsWith('ko')) {
    return 'ko-KR';
  }
  if (locale.startsWith('ja')) {
    return 'ja-JP';
  }
  if (locale.startsWith('vi')) {
    return 'vi-VN';
  }
  if (locale.startsWith('ms')) {
    return 'ms-MY';
  }
  return 'en-US';
}

/** 主站路径前缀（简体默认无前缀） */
export function gcsaMainSiteLocalePrefix(locale: SiteFooterLocale): string {
  if (locale === 'zh-CN') {
    return '';
  }
  return `/${locale}`;
}
